<template>
  <div class="deposit">
    <el-card class="deposit-card1">
      <div id="guide-step7">
        <div class="divider"><h3>{{$t('messages.deposit.deposit1')}}</h3></div>
        <p class="deposit-event-tips">
          {{$t('messages.deposit.deposit12')}}
          <br />
          {{$t('messages.deposit.deposit13')}}
        </p>
        <priceTip></priceTip>
      </div>
      <p class="deposit-desc">{{$t('messages.deposit.deposit14')}}</p>
      <el-tabs v-model="active" class="deposit-tabs">
        <el-tab-pane :label="$t('messages.record.record1')" name="stripe" class="stripe" v-if="show_dbs_bank !== 1">
          <el-form :model="form" :rules="rules" ref="deposit">
            <el-row :gutter="12">
              <el-col :span="showMobile ? 14 : 8">
                <el-form-item prop="amount">
                  <el-input v-model="form.amount" @input="allNumber(form.amount)">
                    <template slot="prepend">
                      $
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" style="width:auto;">
                <div class="bonus-tip">{{ bonusTip }} {{$t('messages.other.other62')}}</div>
              </el-col>
              <el-col :span="24" v-if="showMobile" class="payment-del">
                <div>
                  <div class="payment-del-left">
                    <p>
                      <span>{{$t('messages.deposit.deposit15')}}</span>
                      <span>{{ form.amount ? `$${form.amount}` : 0 }}</span>
                    </p>
                    <p>
                      <span>{{$t('messages.deposit.deposit16')}}</span>
                      <span style="color: #3ACE75;">{{ bonusTipMobile || 0 }}</span>
                    </p>
                  </div>
                  <el-button type="primary" @click="deposit" style="height: 30px">
                    {{$t('messages.deposit.deposit17')}}
                  </el-button>
                </div>
              </el-col>
              <el-col :span="2" v-else>
                <el-button type="primary" @click="deposit" style="height: 30px">{{$t('messages.deposit.deposit17')}}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div class="pays">
            <div class="pays-div">
              <el-tooltip
                class="pay-item"
                effect="dark"
                content="Visa"
                placement="bottom"
                popper-class="pay-pop"
              >
                <img src="../../assets/img/pay1.png" alt="example" width="70" />
              </el-tooltip>
              <el-tooltip
                class="pay-item"
                effect="dark"
                content="Mastercard"
                placement="bottom"
                popper-class="pay-pop"
              >
                <img src="../../assets/img/pay2.png" alt="example" width="70" />
              </el-tooltip>
              <el-tooltip
                class="pay-item"
                effect="dark"
                content="China UnionPay"
                placement="bottom"
                popper-class="pay-pop"
              >
                <img src="../../assets/img/pay3.png" alt="example" width="70" />
              </el-tooltip>
            </div>
            <div class="pays-div-r">
              <img src="../../assets/img/i-tip.png" width="14" />
              {{$t('messages.deposit.deposit18')}}
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('messages.deposit.deposit19')" name="bank" class="bank">
          <div class="payment-info-bank-wrap">
            <div class="info-bank-left">
              <el-result
                icon="success"
                :title="$t('messages.deposit.deposit20')"
                subTitle="Please check the balance later."
                v-if="showSuccess2"
                class="suc-result"
              ></el-result>
              <el-form
                :model="ruleForm2"
                :rules="formRules"
                ref="ruleForm2"
                class="bank-form"
                label-width="160px"
                v-else
              >
                <p class="info-bank-tip">
                  {{$t('messages.deposit.deposit21')}}
                </p>
                <el-form-item
                  :label="$t('messages.deposit.deposit22')"
                  prop="transaction_id"
                  required
                  class="form-item2"
                >
                  <el-input v-model="ruleForm2.transaction_id" style="width:240px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('messages.deposit.deposit23')" required class="form-item">
                  <el-col :span="11" class="date-row">
                    <el-form-item prop="date" class="datep">
                      <el-date-picker
                        type="date"
                        :placeholder="$t('messages.deposit.deposit23')"
                        v-model="ruleForm2.date"
                        style="width:240px"
                        value-format="yyyy-MM-dd"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                </el-form-item>
                <el-form-item :label="$t('messages.deposit.deposit24')" prop="amount" required class="form-item2">
                  <el-input v-model="ruleForm2.amount" style="width:240px"></el-input>
                </el-form-item>
                <div class="info-bank-btn" @click="submitForm('ruleForm2')">{{$t('messages.deposit.deposit43')}}</div>
              </el-form>
            </div>
            <div class="info-bank-right">
              <div class="payment-info payment-info-bank">
                <div class="payment-info-card">
                  <div class="payment-info-card-item">
                    <p class="card-key">{{$t('messages.deposit.deposit25')}}</p>
                    <p class="card-value">{{ banksInfo[show_dbs_bank].account_name }}</p>
                  </div>
                  <div class="payment-info-card-item">
                    <p class="card-key">{{$t('messages.deposit.deposit26')}}</p>
                    <p class="card-value">{{ banksInfo[show_dbs_bank].bank_account }}</p>
                  </div>
                  <div class="payment-info-card-item">
                    <p class="card-key">{{$t('messages.deposit.deposit27')}}</p>
                    <p class="card-value">{{ banksInfo[show_dbs_bank].bank_name }}</p>
                  </div>
                  <div class="payment-info-card-item">
                    <p class="card-key">{{$t('messages.deposit.deposit28')}}</p>
                    <p class="card-value">{{ banksInfo[show_dbs_bank].bank_address }}</p>
                  </div>
                  <div class="payment-info-card-item">
                    <p class="card-key">{{$t('messages.deposit.deposit29')}}</p>
                    <p class="card-value">{{ banksInfo[show_dbs_bank].swift_code }}</p>
                  </div>
                  <div class="payment-info-card-item">
                    <p class="card-key">{{$t('messages.deposit.deposit30')}}</p>
                    <p class="card-value">{{ banksInfo[show_dbs_bank].bank_code }}</p>
                  </div>
                  <div class="payment-info-card-item">
                    <p class="card-key">{{$t('messages.deposit.deposit31')}}:</p>
                    <p class="card-value">{{ `${todayYear} ${uid}` }}</p>
                  </div>
                </div>
                <div class="payment-info-copy" @click="copyPayInfo('bank')">
                  {{$t('messages.deposit.deposit32')}}
                </div>
              </div>
            </div>
          </div>

          <payment-note></payment-note>
        </el-tab-pane>
        <div class="thank-content" id="thankGive">
          <div class="thank-content-tips">
            <!-- <img src="../../assets/img/thank-money-logo.png"/> -->
            <p>Valentine's BONUS</p>
          </div>
          <div style="margin-bottom: 8px;">
            During Valentine's Day (February 14-24), ASOGrow will hold promotional activities, and
            the following are the promotional details:
          </div>
          <div style="line-height: initial;">
            <span style="font-weight: bold;">Step 1</span>
            : Recharge up to $100 and above, you can get
            <a>10% bonus</a>
            to your payment!
          </div>
          <div style="line-height: initial;">
            <span style="font-weight: bold;">Step 2</span>
            : Consume up to $200 and above, you can get
            <a>10% bonus</a>
            to your cost!
          </div>
          <div class="thank-content-tips">
            <p>The more you recharge and consume, the more bonus you will get!</p>
          </div>
          <div>
            You can get 10% bonus on every payment equal to or greater than $100 during the
            promotion.
          </div>
          <div>
            You can get 10% bonus on every cost equal to or greater than $200(only for the amount
            recharged during the promotion) during the promotion.
          </div>
          <div class="thank-content-tips">
            <p>Please note:</p>
          </div>
          <div>
            1. If you apply for a refund, the amount of refund does not include the amount of bonus.
          </div>
          <div>
            2. The bonus amount will be released to your account after you contact our customer
            service staff.
          </div>
          <div>
            3. If you do not use the bonus within six months after receiving the bonus, we will
            recall the bonus.
          </div>
          <div>
            4. If you have other questions, please feel free to contact our customer service through
            the button at the bottom right.
          </div>
        </div>
      </el-tabs>
    </el-card>

    <el-card id="myPayment">
      <section class="panel">
        <div class="divider"><h3>{{$t('messages.deposit.deposit33')}}</h3></div>
        <el-row style="margin-bottom: 40px;">
          <el-table
            v-loading="loading"
            :empty-text="$t('messages.myCampaign.list10')"
            :fit="true"
            border
            :data="list"
            class="deposit-table"
          >
            <el-table-column
              prop="id"
              :label="$t('messages.record.record11')"
              :width="showMobile ? 60 : 'auto'"
            ></el-table-column>
            <el-table-column :label="$t('messages.myCampaign.list6')">
              <template slot-scope="scope">
                {{ showLabel(scope.row.third_platform, asoGrowOption.asogrow_order_platform_type) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('messages.myCampaign.list155')">
              <template slot-scope="scope">
                <p style="color: #3ACE75;">{{ `$ ${scope.row.amount}` }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="ut" :label="$t('messages.deposit.deposit34')" v-if="showMobile" :width="96">
              <template slot-scope="scope">
                {{ formatDate(scope.row.ut) }}
              </template>
            </el-table-column>
            <el-table-column prop="ut" :label="$t('messages.deposit.deposit34')" v-else></el-table-column>
            <el-table-column prop="third_id" :label="$t('messages.deposit.deposit22')" v-if="!showMobile">
              <template slot-scope="scope">
                <p :title="scope.row.third_id">{{ scope.row.third_id }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <pagination :page="page" @sizeChange="getList" @currentChange="getList"></pagination>
      </section>
    </el-card>

    <el-dialog :title="$t('messages.deposit.deposit48')" :visible.sync="remindVisible" width="600px" class="remind-dialog">
      <div class="remind-content">
        <p class="icon-warning-box">
          <i class="iconfont icon-warning"></i>
        </p>
        <p class="remind-text">{{ $t('messages.deposit.deposit49') }}</p>
        <p class="remind-text">
          {{ $t('messages.deposit.deposit50') }}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="closeRemind">
          {{ $t('messages.deposit.deposit51') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :title="$t('messages.deposit.deposit52')" :visible.sync="successVisible" width="600px" class="remind-dialog">
      <div class="success-content">
        <p class="icon-success-box">
          <i class="iconfont icon-circle-check"></i>
        </p>
        <p class="success-text">
          {{ $t('messages.deposit.deposit53') }}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="viewPayment">{{ $t('messages.deposit.deposit54') }}</el-button>
        <el-button type="primary" @click="routerToCampaign">{{ $t('messages.deposit.deposit55') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="$t('messages.deposit.deposit56')" :visible.sync="failVisible" width="600px" class="remind-dialog">
      <div class="fail-content">
        <p class="icon-fail-box">
          <i class="iconfont icon-circle-close"></i>
        </p>
        <p class="fail-text">{{ $t('messages.deposit.deposit57') }}</p>
        <p class="fail-text">
          {{$t('messages.myCampaign.list32')}}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="failVisible = false">{{ $t('messages.deposit.deposit42') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { asogrowCN } from '@/js/varible'
import pagination from '../../components/pagination.vue'
import priceTip from '../../components/priceTip.vue'
import paymentNote from './paymentNote.vue'
import dayjs from 'dayjs'
import { funCalc } from '@common/js/common'
import { guide } from '@/js/intro'
import { throttleFn } from '@/js/common'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    pagination,
    priceTip,
    paymentNote,
  },
  data() {
    return {
      first_top_up: 0, // 1代表是首次充值，0代表不是
      showSuccess: false,
      showSuccess2: false,
      showSuccess3: false,
      asogrowCN,
      asoGrowOptionEN: {},
      formRules: {
        transaction_id: [
          this.createRequiredRule(this,'messages.createCampaign.create141'),
        ],
        amount: [
          this.createRequiredRule(this,'messages.createCampaign.create142'),
        ],
        date: [
          this.createRequiredRule(this,'messages.createCampaign.create143'),
        ],
      },
      ruleForm: {
        transaction_id: '',
        amount: '',
        date: '',
        type: 'Payoneer',
      },
      ruleForm2: {
        transaction_id: '',
        amount: '',
        date: '',
        type: 'Bank Transfer',
      },
      ruleForm3: {
        transaction_id: '',
        amount: '',
        date: '',
        type: 'PayPal',
      },
      active: 'stripe', //
      form: {
        amount: '',
      },
      rules: {
        amount: [
          this.createRequiredRule(this,'messages.createCampaign.create144'),
          {
            validator: (rule, value, callback) => {
              if (Number(value) < 20) {
                callback(new Error(this.$t('messages.createCampaign.create133')))
                return
              }
              if (Number(value) > 100000) {
                callback(new Error(this.$t('messages.createCampaign.create134')))
                return
              }
              callback()
            },
          },
        ],
      },
      loading: false,
      list: [],
      page: {
        tot: 0,
        cur: 1,
        per: 20,
      },
      remindVisible: false,
      successVisible: false,
      failVisible: false,
      asoGrowOption: {},
      todayYear: '',
      uid: '',
      need: '',
      showBonusTip: false,
      bonusTip: '+ $0',
      bonusTipMobile: '',
      showMobile: false,
      show_dbs_bank: 0,
      banksInfo: {
        0: {
          account_name: 'YOUMI TECHNOLOGY (HK) LIMITED',
          bank_account: '848650966838',
          bank_name: 'HSBC Hong Kong',
          bank_address: '1 Queen\'s Road Central,Hong Kong',
          swift_code: 'HSBCHKHHHKH',
          bank_code: '004',
        },
        1: {
          account_name: 'YOUMI TECH PTE. LTD',
          bank_account: '072-005188-2',
          bank_name: 'DBS Bank',
          bank_address: '12 Marina Boulevard,Level 42 Marina Bay Financial Centre Tower 3 S018982',
          swift_code: 'DBSSSGSG',
          bank_code: '7171',
        },
      },
    }
  },
  computed: {
    isEnglish(){
      return this.$i18n.locale === 'en'
    },
    payoneerMessage() {
      return `${this.$t('messages.deposit.deposit62')} youmi@youmi.net 
      ${this.$t('messages.deposit.deposit31')}: ${this.todayYear} ${this.uid}`
    },
    bankMessage() {
      let obj = this.banksInfo[this.show_dbs_bank]
      return (
        `${this.$t('messages.deposit.deposit25')} ${obj.account_name} \nA` +
        `ccount: ${obj.bank_account} \n${this.$t('messages.deposit.deposit27')} ${obj.bank_name} \n${this.$t('messages.deposit.deposit28')} ${obj.bank_address} \n${this.$t('messages.deposit.deposit29')} ${obj.swift_code} \n${this.$t('messages.deposit.deposit30')} ${obj.bank_code} \n${this.$t('messages.deposit.deposit31')} ${this.todayYear} ${this.uid}`
      )
    },
    paypalMessage() {
      return `${this.$t('messages.deposit.deposit60')}: youmi@youmi.net 
${this.$t('messages.deposit.deposit25')} YOUMI TECH PTE. LTD
${this.$t('messages.deposit.deposit61')}: FLOOR17，R&D BUILDING, NO.26. QINGLAN STREET HIGHER EDUCATION MEGA CENTRE .GUANGZHOU.GUANGDONG. CHINA
${this.$t('messages.deposit.deposit31')} ${this.todayYear} ${this.uid}`
    },
    ...mapState(['holiday']),
    ...mapGetters(['holidayNow']),
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.refreshFormValidateOnLocaleChange(this, ['ruleForm2'])
      }
    },
    isEnglish: {
      handler(newVal) {
        if(newVal){
          this.asoGrowOption = this.asoGrowOptionEN
        }else{
          this.asoGrowOption = this.asogrowCN
        }
      },
      immediate: true,
    },
    list: {
      handler(newVal) {
        if (newVal.length > 0) {
          if (Array.isArray(newVal)) {
            if (newVal.some(i => i.third_platform !== 4)) {
              this.showBonusTip = false
            } else {
              this.showBonusTip = true
            }
          }
        } else {
          this.showBonusTip = true
        }
      },
    },
    '$store.state.introStepInfo.currentStep': {
      handler(newVal, oldVal) {
        if (parseInt(sessionStorage.getItem('complete_guide'))) return
        if (newVal === 6 && oldVal === 7) {
          this.$router.push('/snapshot')
        }
        if (newVal === 7 && (oldVal === 6 || !oldVal)) {
          this.handleGuide()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initNeed()
    this.initYear()
    this.getOptions()
    this.getList()
    this.showResultDialog()
    this.getProfile()
    this.getDefaultDate()
    window.addEventListener('resize', this.move)
    let width = document.body.clientWidth || document.documentElement.clientWidth
    this.showMobile = width < 801
  },
  destroyed() {
    window.removeEventListener('resize', this.move)
  },
  methods: {
    handleGuide(step) {
      this.$nextTick(() => {
        guide([
          {
            title: this.$t('messages.guide.guide8'),
            intro: `${this.$t('messages.guide.guide9')}(7/7)`,
            element: document.querySelector('#guide-step7'),
          },
        ])
      })
    },
    move() {
      let width = document.body.clientWidth || document.documentElement.clientWidth
      this.showMobile = width < 801
    },
    getDefaultDate() {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      var defaultDate = `${year}-${month}-${date}`
      this.ruleForm.date = defaultDate
      this.ruleForm2.date = defaultDate
      this.ruleForm3.date = defaultDate
      return defaultDate
    },
    submitFormPost: throttleFn(function() {
      let active = this.active
      let params =
        active === 'payoneer' ? this.ruleForm : active === 'bank' ? this.ruleForm2 : this.ruleForm3
      this.$http.post('/api/deposit/arti_payment/', params).then(data => {
        if (active === 'payoneer') {
          this.showSuccess = true
        } else if (active === 'bank') {
          window.lintrk('track', { conversion_id: 16222924 })
          this.showSuccess2 = true
        } else {
          this.showSuccess3 = true
        }
      })
    }, 3000),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitFormPost()
        } else {
          return false
        }
      })
    },
    getProfile() {
      this.$http.get('/api/accounts/profile/').then(data => {
        this.uid = data.uid
        this.first_top_up = data.first_top_up
        this.show_dbs_bank = data.show_dbs_bank || 0
        this.$store.commit('PROFILE', data)
        if (data.show_dbs_bank) {
          this.active = 'bank'
        }
      })
    },
    initYear() {
      this.todayYear = dayjs().year()
    },
    initNeed() {
      if (this.$route.query.need) {
        this.form.amount = String(Math.abs(Math.ceil(Number(this.$route.query.need))))
      }
    },
    showResultDialog() {
      if (this.$route.query.success) {
        let success = this.$route.query.success
        if (success === '1') {
          this.successVisible = true
          window.lintrk('track', { conversion_id: 16222924 })
        } else if (success === '0') {
          this.failVisible = true
        }
      }
    },
    getOptions() {
      this.$http
        .get('/api/data/settings/', {
          params: {
            fields: 'asogrow',
          },
        })
        .then(data => {
          this.asoGrowOptionEN = data.data.asogrow
          if(this.isEnglish){
            this.asoGrowOption = data.data.asogrow
          }else{
            this.asoGrowOption = this.asogrowCN
          }
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    allNumber(value) {
      this.form.amount = value.replace(/[^\d]/g, '')
      let amount = Number(this.form.amount)
      let num = 0
      if (this.holidayNow) {
        if (amount > 0 && amount <= 999) {
          num = funCalc([amount, 0.08], 2, 1)
        } else if (amount >= 1000) {
          num = funCalc([amount, 0.12], 2, 1)
        } else {
          num = 0
        }
      } else {
        if (amount >= 500 && amount <= 999) {
          num = funCalc([amount, 0.05], 2, 1)
        } else if (amount >= 1000 && amount <= 4999) {
          num = funCalc([amount, 0.1], 2, 1)
        } else if (amount >= 5000) {
          num = funCalc([amount, 0.12], 2, 1)
        } else {
          num = 0
        }
      }
      this.bonusTip = `+ $${num}`
      this.bonusTipMobile = `$${amount + num}`
    },
    deposit() {
      var winRef
      let flag = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
      this.$refs.deposit.validate(valid => {
        let params = {
          amount: Number(this.form.amount),
        }
        if (valid) {
          if (flag) {
            winRef = window.open('', '_blank')
          }
          this.$http
            .post('/api/deposit/stripe_recharge/', params)
            .then(data => {
              let url = data.data.url
              if (flag) {
                winRef.location = url
              } else {
                window.open(url, '_blank')
              }
              this.remindVisible = true
            })
            .catch(error => {
              this.notifyOpen('Error', this.executeError(error), 'error')
            })
        }
      })
    },
    getList() {
      this.loading = true
      this.$http
        .get('/api/deposit/deposit/', {
          params: {
            p: this.page ? this.page.cur : 1,
            n: this.page ? this.page.per : 20,
          },
        })
        .then(data => {
          this.loading = false
          this.list = data.data
          this.changePageItem(this.page, data)
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    closeRemind() {
      this.remindVisible = false
      this.getList()
    },
    viewPayment() {
      this.successVisible = false
      let scrollBody = document.getElementById('elMain')
      let myPayment = document.getElementById('myPayment')
      scrollBody.scrollTop = myPayment.offsetTop - 60
      this.getList()
    },
    routerToCampaign() {
      this.successVisible = false
      this.$router.push('/campaign/create')
    },
    copyPayInfo(payMethod) {
      let message = ''
      if (payMethod === 'payoneer') {
        message = this.payoneerMessage
      } else if (payMethod === 'bank') {
        message = this.bankMessage
      } else {
        message = this.paypalMessage
      }
      this.$copyText(message).then(
        () => {
          this.notifyOpen(this.$t('messages.createCampaign.create159'))
        },
        e => {
          this.notifyOpen('Error', this.$t('messages.createCampaign.create160'), 'error')
          console.log(e)
        }
      )
    },
  },
}
</script>

<style lang="scss">
.deposit .deposit-card1 .el-card__body {
  padding-left: 0;
  padding-right: 0;
}
.pay-pop {
  background: #6b6d71 !important;
}
.pay-pop[x-placement^='bottom'] .popper__arrow::after {
  border-bottom-color: #6b6d71 !important;
}
.pay-pop[x-placement^='top'] .popper__arrow::after {
  border-top-color: #6b6d71 !important;
}
.deposit {
  .thank-content {
    display: none;
    color: #6b6d71;
    font-size: 14px;
    border-radius: 4px;
    padding: 24px;
    background: #f5f7fa;
    margin-top: 20px;
    line-height: 22px;
    .thank-content-tips {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      margin-top: 24px;
      > img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
      > p {
        font-size: 14px;
        font-weight: 700;
        color: #303133;
      }
      &:first-child {
        margin-top: 0;
        > p {
          font-size: 18px;
        }
      }
    }
    > div {
      > a {
        text-decoration: none;
      }
      > a:hover {
        text-decoration: none;
      }
    }
  }
  .pays {
    display: flex;
    align-items: center;
    .pays-div {
      display: flex;
      align-items: center;
    }
    .pays-div-r {
      font-weight: 400;
      color: #606266;
      font-size: 14px;
      > img {
        display: none;
      }
    }
    .pay-item {
      margin-right: 22px;
    }
  }
  .el-card {
    margin-bottom: 24px;
    .el-card__body {
      padding-top: 0;
      padding-bottom: 50px;
    }
  }
  .deposit-event-tips {
    display: none;
    color: #e6a23c;
    line-height: 1.8em;
    margin-bottom: 24px;
  }
  .deposit-desc {
    margin-bottom: 24px;
    font-weight: bold;
    color: #303133;
    font-size: 16px;
    padding-left: 28px;
    padding-right: 28px;
  }
  .bonus-tip {
    color: #3ace75;
    height: 32px;
    line-height: 32px;
  }
  .payment-info-bank-wrap,
  .payment-info-wrap {
    display: flex;
    margin-bottom: 35px;
  }
  .info-bank {
    border-left: 1px solid #eee;
  }
  .info-bank-right,
  .payment-info-right {
    margin-left: 60px;
    padding-left: 60px;
    border-left: 1px solid #eee;
  }
  .info-bank-left,
  .payment-info-left {
    min-width: 384px;
    .el-result__subtitle p,
    .el-result__title p {
      font-size: 16px;
      color: #6b6d71;
      line-height: 1.3;
    }
    .suc-result {
      .el-result__icon svg {
        width: 90px !important;
        height: 90px !important;
      }
    }
    .info-bank-tip {
      color: #e6a23c;
      margin-bottom: 24px;
    }
    .info-bank-btn {
      background: #1861f2;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border: 1px solid #1861f2;
      cursor: pointer;
      width: 150px;
      height: 40px;
      border-radius: 8px;
      margin: 34px auto 34px 150px;
      &:hover {
        background: #3399d6;
        border-color: #3399d6;
      }
    }
  }
  .payment-info {
    border: 1px solid #e4e7ed;
    width: 400px;
    background: #f6f8fb;
    border-radius: 4px;
    padding: 24px 0 0 0;
    .payment-info-card {
      .payment-info-card-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        .card-key {
          width: 150px;
          text-align: right;
        }
        .card-value {
          width: 200px;
          text-align: left;
        }
      }
    }
    .payment-info-copy {
      text-align: center;
      border-top: 1px solid #e4e7ed;
      cursor: pointer;
      padding: 24px 0;
      color: #1861f2;
    }
  }
  .payment-info-bank {
    width: 500px;
    min-width: 500px;
    max-width: 500px;
    .payment-info-card {
      .payment-info-card-item {
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 24px;
        }
        .card-value {
          width: 300px;
        }
      }
    }
  }
  .deposit-tabs,
  #guide-step7 {
    padding-left: 28px;
    padding-right: 28px;
  }
}
.remind-content {
  .icon-warning-box {
    text-align: center;
    margin-bottom: 12px;
    i {
      color: #e6a23c;
      font-size: 70px;
    }
  }
  .remind-text {
    margin: 0 auto 8px;
    font-size: 16px;
    text-align: center;
  }
}
.success-content {
  .icon-success-box {
    text-align: center;
    margin-bottom: 30px;
    i {
      color: #67c23a;
      font-size: 70px;
    }
  }
  .success-text {
    margin: 0 auto 8px;
    font-size: 16px;
    text-align: center;
  }
}
.fail-content {
  .icon-fail-box {
    text-align: center;
    margin-bottom: 30px;
    i {
      color: #f56c6c;
      font-size: 70px;
    }
  }
  .fail-text {
    margin: 0 auto 8px;
    font-size: 16px;
    text-align: center;
  }
}

.datep{
  .el-form-item__error{
    width: 240px !important;
  }
}

@media screen and (max-width: 1366px) {
  .deposit .info-bank-right {
    margin-left: 20px;
    margin-left: 10px;
    padding-left: 10px;
    border: none;
  }
  .payment-info-right {
    margin-left: 20px !important;
    margin-left: 10px !important;
    padding-left: 10px !important;
    border: none !important;
  }
  .info-bank-left,
  .payment-info-left {
    min-width: 364px;
  }
}
@media screen and (max-width: 1100px) {
  .deposit .info-bank-right,
  .payment-info-right {
    margin-left: 10px;
    margin-left: 5px;
    padding-left: 5px;
  }
  .payment-info-right {
    margin-left: 10px !important;
    margin-left: 5px !important;
    padding-left: 5px !important;
  }
  .info-bank-left,
  .payment-info-left {
    min-width: 345px;
  }
  .deposit {
    .pays {
      flex-direction: column;
      align-items: flex-start;
    }
    .payment-info-wrap {
      flex-direction: column-reverse !important;
      .payment-info-right {
        width: calc(100% - 10px) !important;
        margin-left: 0 !important;
        margin-bottom: 14px;
        .payment-info {
          width: 100%;
          min-width: auto !important;
          .payment-info-card {
            .payment-info-card-item {
              .card-key,
              .card-value {
                width: 48% !important;
              }
            }
          }
        }
      }
      .payment-info-left {
        width: 100%;
        min-width: auto !important;
        .bank-form {
          width: 100%;
          .form-item2 {
            width: 100%;
            .el-form-item__label {
              text-align: left !important;
              min-width: 160px !important;
              width: 160px !important;
              font-size: 14px;
            }
            .el-form-item__content {
              width: calc(100% - 160px) !important;
              margin-left: 160px !important;
              .el-input {
                width: 100% !important;
              }
            }
          }
          .form-item {
            width: 100%;
            .el-form-item__label {
              text-align: left !important;
              min-width: 160px !important;
              font-size: 14px;
              width: 160px !important;
            }
          }
          .date-row {
            width: 100%;
            .el-date-editor.el-input {
              width: 100% !important;
            }
          }
          .line {
            display: none;
          }
        }
        .info-bank-btn {
          margin: 0 auto !important;
        }
      }
    }
    .payment-info-bank-wrap {
      flex-direction: column-reverse !important;
      flex-direction: column-reverse !important;
      .info-bank-right {
        width: calc(100% - 10px) !important;
        margin-left: 0 !important;
        margin-bottom: 14px;
        .payment-info {
          width: 100%;
          min-width: auto !important;
          .payment-info-card {
            .payment-info-card-item {
              .card-key {
                width: 40% !important;
              }
              .card-value {
                width: 50% !important;
                padding-right: 10px;
              }
            }
          }
        }
      }
      .info-bank-left {
        width: 100%;
        min-width: auto !important;
        .bank-form {
          width: 100%;
          .form-item2 {
            width: 100%;
            .el-form-item__label {
              text-align: left !important;
              min-width: 160px !important;
              width: 160px !important;
              font-size: 14px;
            }
            .el-form-item__content {
              width: calc(100% - 160px) !important;
              margin-left: 160px !important;
              .el-input {
                width: 100% !important;
              }
            }
          }
          .form-item {
            width: 100%;
            .el-form-item__label {
              text-align: left !important;
              min-width: 160px !important;
              width: 160px !important;
              font-size: 14px;
            }
          }
          .date-row {
            width: 100%;
            .el-date-editor.el-input {
              width: 100% !important;
            }
          }
          .line {
            display: none;
          }
        }
        .info-bank-btn {
          margin: 0 auto !important;
        }
      }
    }
  }
}

@media screen and (max-width: 801px) {
  .deposit {
    #myPayment {
      .el-table th.el-table__cell > .cell {
        padding-left: 4px !important;
        padding-right: 4px !important;
        text-align: center !important;
      }
      .el-table td.el-table__cell div {
        padding-left: 4px !important;
        padding-right: 4px !important;
        text-align: center !important;
        overflow: inherit;
        white-space: inherit;
        word-break: break-word;
      }
      .el-card__body {
        padding-left: 14px !important;
        padding-right: 10px !important;
      }
      .pagination {
        .el-row--flex.is-justify-space-between {
          flex-direction: column-reverse !important;
          align-items: flex-start !important;
        }
      }
      .deposit-table {
        margin-bottom: 10px;
      }
    }
    .stripe {
      .payment-del {
        > div {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .payment-del-left {
            margin-right: 20px;
            > p {
              display: flex;
              align-items: center;
              > span {
                &:first-child {
                  display: inline-block;
                  width: 120px;
                }
              }
            }
          }
        }
      }
    }
    .pays {
      .pays-div-r {
        > img {
          display: inline-block !important;
          vertical-align: middle;
          margin-right: 2px;
        }
      }
    }
    .remind-dialog {
      .el-dialog {
        width: 96% !important;
      }
    }
    .el-card {
      .el-card__body {
        padding-left: 20px !important;
        padding-right: 20px !important;
      }
    }
    .deposit-tabs {
      .el-tabs__item {
        line-height: 40px !important;
      }
    }
  }
}
</style>
